import { Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  renderEmptyState: boolean;
  xs: [number, number];
};

const AccumulationsEmptyState = ({ renderEmptyState, xs }: Props) => {
  const { t } = useTranslation();

  if (!renderEmptyState) return null;

  return (
    <>
      <Grid item xs={xs[0]} />
      <Grid item xs={xs[1]} mt={2}>
        <Typography textAlign="left">{t("common:noSearchResults")}</Typography>
      </Grid>
    </>
  );
};

export default memo(AccumulationsEmptyState);
